<script lang="ts">
  import { onMount } from "svelte"

  let props = $props()
  let flywheel: FlywheelType = props.flywheel
  let radius = props.radius || 350

  const RADIUS = radius
</script>

<div class="flex justify-center items-center">
  <div class="relative w-full">
    <svg
      width={RADIUS * 2}
      height={RADIUS * 2}
      class="mx-auto"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x={RADIUS / 2}
        y={RADIUS / 2}
        width="200"
        height="100"
        style="fill: none; stroke: green; stroke-width: 2px;"
      >
      </rect>
      <path id="P" pathLength="80" d="M388 400h72" stroke="blue" />
      <text>
        <textPath
          href="#P"
          startoffset="100"
          text-anchor="middle"
          dominant-baseline="middle"
          fill="green"
          font-size="14px">{flywheel.title}</textPath
        >
      </text>
      <g>
        <rect x="0" y="0" width="100" height="100" fill="red"></rect>
        <text x="0" y="50" font-family="Verdana" font-size="20" fill="blue"
          >{flywheel.title}</text
        >
      </g>
    </svg>
  </div>
</div>
<svg width="250" height="250" xmlns="http://www.w3.org/2000/svg">
  <rect x="0" y="0" width="250" height="250" fill="aquamarine" />
  <foreignobject x="0" y="0" width="250" height="250">
    <div xmlns="http://www.w3.org/1999/xhtml">
      <div>
        Here is a long text that runs more than one line and works as a
        paragraph
      </div>
      <br />
      <div>This is <u>UNDER LINE</u> one</div>
      <br />
      <div>This is <b>BOLD</b> one</div>
      <br />
      <div>This is <i>Italic</i> one</div>
    </div>
  </foreignobject>
</svg>
